var _a;
// SPDX-FileCopyrightText: 2026 Sequent Tech Inc <legal@sequentech.io>
//
// SPDX-License-Identifier: AGPL-3.0-only
import { EScopeSelector, } from "../types";
var PORTAL_WORDS = (_a = {},
    _a[EScopeSelector.REGION] = {
        label: "monitoring.selectors.region",
        all: "monitoring.selectors.allRegions",
    },
    _a[EScopeSelector.POST] = {
        label: "monitoring.selectors.post",
        all: "monitoring.selectors.allPosts",
    },
    _a[EScopeSelector.COUNTRY] = {
        label: "monitoring.selectors.country",
        all: "monitoring.selectors.allCountries",
    },
    _a);
/**
 * What a dashboard selector is called: the settings' words (a university may
 * say "Faculty"), else the portal's. A viewer limited by permission labels sees
 * only some Posts, so their "All" says so.
 */
export function selectorWords(selector, settings, t, restricted) {
    var _a;
    var configured = (_a = settings === null || settings === void 0 ? void 0 : settings.selectors) === null || _a === void 0 ? void 0 : _a[selector];
    var words = configured !== null && configured !== void 0 ? configured : {
        label: t(PORTAL_WORDS[selector].label),
        all: t(PORTAL_WORDS[selector].all),
    };
    if (selector !== EScopeSelector.POST || !restricted)
        return words;
    return {
        label: words.label,
        all: configured
            ? t("monitoring.selectors.authorizedOnly", { all: configured.all })
            : t("monitoring.selectors.allAuthorizedPosts"),
    };
}
var optionsOf = function (options, selector) {
    switch (selector) {
        case EScopeSelector.REGION:
            return options.regions;
        case EScopeSelector.POST:
            return options.posts;
        case EScopeSelector.COUNTRY:
            return options.countries;
    }
};
export function optionLabel(options, selector, key) {
    var _a, _b;
    return (_b = (_a = optionsOf(options, selector).find(function (option) { return option.key === key; })) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : key;
}
/**
 * On an election's page its Post is fixed, and with it the Post's Region:
 * neither is offered.
 */
export var PINNED_BY_POST = new Set([
    EScopeSelector.REGION,
    EScopeSelector.POST,
]);
/** `All regions · Madrid · Spain`: the scope a dashboard or export is shown at. */
export function scopeLabel(_a) {
    var scope = _a.scope, selectors = _a.selectors, options = _a.options, settings = _a.settings, t = _a.t, restricted = _a.restricted, pinnedPost = _a.pinnedPost;
    var pinned = pinnedPost ? options.posts.find(function (post) { return post.key === pinnedPost; }) : undefined;
    return selectors
        .map(function (selector) {
        var _a;
        var key = !pinnedPost
            ? scope[selector]
            : selector === EScopeSelector.POST
                ? pinnedPost
                : selector === EScopeSelector.REGION
                    ? ((_a = pinned === null || pinned === void 0 ? void 0 : pinned.region) !== null && _a !== void 0 ? _a : undefined)
                    : scope[selector];
        return key
            ? optionLabel(options, selector, key)
            : selectorWords(selector, settings, t, restricted).all;
    })
        .join(" · ");
}
